import { render, staticRenderFns } from "./AddEPaper2.vue?vue&type=template&id=bf21b99c&scoped=true"
import script from "./AddEPaper2.vue?vue&type=script&lang=js"
export * from "./AddEPaper2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf21b99c",
  null
  
)

export default component.exports